<template>
    <div>
        <div class="card">
            <div class="card-header d-flex justify-content-between">
                <slot></slot>
            </div>
            <div class="card-body small">
                <div
                    v-for="user_coupon in coupons"
                    :key="`user_coupon_${user_coupon.id}`">
                    <div class="vc-user-coupon d-flex align-items-center">
                        <div>
                            <div class="vc-user-coupon__name small text-muted">{{ user_coupon.name }}</div>
                            <div class="vc-user-coupon__discount">
                                <span>{{ user_coupon.discount.toLocaleString() }}</span><!--
                                        --><span>円引き</span>
                            </div>
                            <div class="vc-user-coupon__expired_at">
                                <span><b-icon-clock/>&nbsp;{{ expiredDate(user_coupon) }}</span>
                                <span>{{ expiredTime(user_coupon) }}</span>
                                <span>まで（{{ timezone }}）</span>
                            </div>
                            <div class="vc-user-coupon__restrict">
                                <div v-if="user_coupon.has_doctor_menu">
                                    <div class="d-inline-block">メニュー限定&nbsp;</div>
                                    <template v-if="user_coupon.doctor_menus.length > 2">
                                        <div
                                            v-for="n in 2"
                                            class="d-inline-block">
                                            <span>{{ `${user_coupon.doctor_menus[n-1].title}（${user_coupon.doctor_menus[n-1].doctor ? user_coupon.doctor_menus[n-1].doctor.full_name : '退会済の医師'}）` }}</span><!--
                                         --><span v-if="n < 2">、</span><!--
                                         --><span v-if="n === 2">…ほか</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div
                                            v-for="(doctor_menu, index) in user_coupon.doctor_menus"
                                            class="d-inline-block">
                                            <span>{{ `${doctor_menu.title}（${doctor_menu.doctor ? doctor_menu.doctor.full_name : '退会済の医師'}）` }}</span><!--
                                         --><span v-if="user_coupon.doctor_menus.length > index + 1">、</span>
                                        </div>
                                    </template>
                                </div>
                                <div v-else-if="user_coupon.has_doctor">
                                    <div
                                        v-for="(doctor, index) in user_coupon.doctors"
                                        class="d-inline-block">
                                        <span>{{ doctor.full_name }}</span><!--
                                     --><span v-if="user_coupon.doctors.length > index + 1">、</span><!--
                                     --><span v-else>&nbsp;医師限定</span>
                                    </div>
                                    <div v-if="user_coupon.doctors.length < 1">退会済の医師限定</div>
                                </div>
                                <div v-if="user_coupon.min_consultation_price">
                                    <span>{{ user_coupon.min_consultation_price.toLocaleString() }}円以上の{{ $locale.consultation_host }}限定</span>
                                </div>
                                <div v-if="user_coupon.is_only_matching">
                                    <span>マッチング予約限定</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="isCouponCode"
                    class="d-flex justify-content-center"
                    :class="{ 'mt-4' : coupons.length > 0 }">
                    <b-button
                        variant="yokumiru-orange"
                        @click="onClickCouponCodeButton">
                        +&nbsp;クーポンコードを入力
                    </b-button>
                </div>
            </div>
        </div>

        <user-coupon-code-modal/>
    </div>
</template>

<script>
    import YokumiruHelper from '../../YokumiruHelper'
    import constants from '../../constants'
    import moment from "moment-timezone"

    export default {
        props: {
            plan: {
                type: Object,
                required: true,
            },
            campaigns: {
                type: Array,
                required: true,
            },
            coupons: {
                type: Array,
                required: true,
            },
            timezone: {
                type: String,
                default: 'Asia/Tokyo',
            },
            isCouponCode: {
                type: Boolean,
                default: false,
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
            }
        },

        methods: {
            /**
             * クーポン使用期限表記（日付）
             *
             * @param {object} coupon
             * @return {string}
             */
            expiredDate: function (coupon) {
                if (coupon.expired_at) {
                    return this.helper.dateForHuman(coupon.expired_at, this.timezone)
                }
                return ''
            },

            /**
             * クーポン使用期限表記（時刻）
             *
             * @param {object} coupon
             * @return {string}
             */
            expiredTime: function (coupon) {
                if (coupon.expired_at) {
                    return this.helper.timeForHuman(coupon.expired_at, this.timezone)
                }
                return ''
            },

            /**
             * クーポンコード入力モーダル表示
             */
            onClickCouponCodeButton: function () {
                bus.$emit('open-modal-user-coupon-code')
            },
        },
    }
</script>

<style lang="scss" scoped>
.vc-user-coupon {
    position: relative;
    padding: 14px 15px;
    margin-bottom: 12px;
    background: #fcfcfc;
    border: 1px solid #dee2e6;
    border-radius: 5px;

    .vc-user-coupon__name {
        font-size: .75rem;
        line-height: 1.3;
    }

    .vc-user-coupon__discount {
        margin-left: 1px;
        color: #5f6366;
        font-size: 1.1rem;
        font-weight: bold;
        line-height: 1.3;

        span {
            &:nth-child(2) {
                font-size: .75rem;
            }
        }
    }

    .vc-user-coupon__expired_at {
        margin-top: 5px;
        color: #5f6366;
        font-size: .7rem;

        span {
            &:nth-child(1),
            &:nth-child(2) {
                font-weight: bold;
            }
        }
    }

    .vc-user-coupon__restrict {
        margin-left: 15px;
        color: #5f6366;
        font-size: .7rem;
    }
}
</style>
